import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import { Spin } from "antd";
import AnchorLayout from "@/components/AnchorLayout";
import { ROUTES } from "@/config/routes";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";

const LoginPage = lazy(() => import("@/pages/login/LoginPage"));
const WorkspacePage = lazy(() => import("@/pages/workspace/WorkspacePage"));
const IncomingCallPage = lazy(() => import("@/pages/calls/IncomingCallPage"));
const CallHistoryPage = lazy(() => import("@/pages/calls/CallHistoryPage"));
const ProfilePage = lazy(() => import("@/pages/profile/ProfilePage"));
const InstagramTaskPage = lazy(
  () => import("@/pages/profile-tasks/InstagramTaskPage"),
);
const PrivatePhotosTaskPage = lazy(
  () => import("@/pages/profile-tasks/PrivatePhotosTaskPage"),
);
const PrivateVideosTaskPage = lazy(
  () => import("@/pages/profile-tasks/PrivateVideosTaskPage"),
);
const WithdrawPage = lazy(() => import("@/pages/withdraw/WithdrawPage"));
const ProfileCompletionPage = lazy(
  () => import("@/pages/profile-completion/ProfileCompletionPage"),
);
const SettingsPage = lazy(() => import("@/pages/settings/SettingsPage"));

function Loading() {
  return (
    <div style={{ minHeight: "100%", display: "grid", placeItems: "center" }}>
      <Spin size="large" />
    </div>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route
          path={ROUTES.login}
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AnchorLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to={ROUTES.workspace} replace />} />
          <Route
            path="profile-completion"
            element={<ProfileCompletionPage />}
          />
          <Route path="workspace" element={<WorkspacePage />} />
          <Route path="calls/incoming" element={<IncomingCallPage />} />
          <Route path="calls/history" element={<CallHistoryPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="profile/instagram" element={<InstagramTaskPage />} />
          <Route
            path="profile/private-photos"
            element={<PrivatePhotosTaskPage />}
          />
          <Route
            path="profile/private-videos"
            element={<PrivateVideosTaskPage />}
          />
          <Route path="withdraw" element={<WithdrawPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to={ROUTES.workspace} replace />} />
      </Routes>
    </Suspense>
  );
}
